import { jsxs as y, Fragment as v, jsx as a } from "react/jsx-runtime";
import U from "react";
function W(l) {
  return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var m = {}, I;
function Y() {
  if (I) return m;
  I = 1;
  var l = U;
  function d(n) {
    return n && typeof n == "object" && "default" in n ? n : { default: n };
  }
  var h = /* @__PURE__ */ d(l);
  function b(n, i) {
    for (var s = 0; s < i.length; s++) {
      var e = i[s];
      e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(n, e.key, e);
    }
  }
  function L(n, i, s) {
    return i && b(n.prototype, i), n;
  }
  var w = typeof process < "u" && process.env && process.env.NODE_ENV === "production", z = function(n) {
    return Object.prototype.toString.call(n) === "[object String]";
  }, B = /* @__PURE__ */ function() {
    function n(s) {
      var e = s === void 0 ? {} : s, t = e.name, r = t === void 0 ? "stylesheet" : t, o = e.optimizeForSpeed, u = o === void 0 ? w : o;
      c(z(r), "`name` must be a string"), this._name = r, this._deletedRulePlaceholder = "#" + r + "-deleted-rule____{}", c(typeof u == "boolean", "`optimizeForSpeed` must be a boolean"), this._optimizeForSpeed = u, this._serverSheet = void 0, this._tags = [], this._injected = !1, this._rulesCount = 0;
      var _ = typeof window < "u" && document.querySelector('meta[property="csp-nonce"]');
      this._nonce = _ ? _.getAttribute("content") : null;
    }
    var i = n.prototype;
    return i.setOptimizeForSpeed = function(e) {
      c(typeof e == "boolean", "`setOptimizeForSpeed` accepts a boolean"), c(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted"), this.flush(), this._optimizeForSpeed = e, this.inject();
    }, i.isOptimizeForSpeed = function() {
      return this._optimizeForSpeed;
    }, i.inject = function() {
      var e = this;
      if (c(!this._injected, "sheet already injected"), this._injected = !0, typeof window < "u" && this._optimizeForSpeed) {
        this._tags[0] = this.makeStyleTag(this._name), this._optimizeForSpeed = "insertRule" in this.getSheet(), this._optimizeForSpeed || (w || console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode."), this.flush(), this._injected = !0);
        return;
      }
      this._serverSheet = {
        cssRules: [],
        insertRule: function(t, r) {
          return typeof r == "number" ? e._serverSheet.cssRules[r] = {
            cssText: t
          } : e._serverSheet.cssRules.push({
            cssText: t
          }), r;
        },
        deleteRule: function(t) {
          e._serverSheet.cssRules[t] = null;
        }
      };
    }, i.getSheetForTag = function(e) {
      if (e.sheet)
        return e.sheet;
      for (var t = 0; t < document.styleSheets.length; t++)
        if (document.styleSheets[t].ownerNode === e)
          return document.styleSheets[t];
    }, i.getSheet = function() {
      return this.getSheetForTag(this._tags[this._tags.length - 1]);
    }, i.insertRule = function(e, t) {
      if (c(z(e), "`insertRule` accepts only strings"), typeof window > "u")
        return typeof t != "number" && (t = this._serverSheet.cssRules.length), this._serverSheet.insertRule(e, t), this._rulesCount++;
      if (this._optimizeForSpeed) {
        var r = this.getSheet();
        typeof t != "number" && (t = r.cssRules.length);
        try {
          r.insertRule(e, t);
        } catch {
          return w || console.warn(`StyleSheet: illegal rule: 

` + e + `

See https://stackoverflow.com/q/20007992 for more info`), -1;
        }
      } else {
        var o = this._tags[t];
        this._tags.push(this.makeStyleTag(this._name, e, o));
      }
      return this._rulesCount++;
    }, i.replaceRule = function(e, t) {
      if (this._optimizeForSpeed || typeof window > "u") {
        var r = typeof window < "u" ? this.getSheet() : this._serverSheet;
        if (t.trim() || (t = this._deletedRulePlaceholder), !r.cssRules[e])
          return e;
        r.deleteRule(e);
        try {
          r.insertRule(t, e);
        } catch {
          w || console.warn(`StyleSheet: illegal rule: 

` + t + `

See https://stackoverflow.com/q/20007992 for more info`), r.insertRule(this._deletedRulePlaceholder, e);
        }
      } else {
        var o = this._tags[e];
        c(o, "old rule at index `" + e + "` not found"), o.textContent = t;
      }
      return e;
    }, i.deleteRule = function(e) {
      if (typeof window > "u") {
        this._serverSheet.deleteRule(e);
        return;
      }
      if (this._optimizeForSpeed)
        this.replaceRule(e, "");
      else {
        var t = this._tags[e];
        c(t, "rule at index `" + e + "` not found"), t.parentNode.removeChild(t), this._tags[e] = null;
      }
    }, i.flush = function() {
      this._injected = !1, this._rulesCount = 0, typeof window < "u" ? (this._tags.forEach(function(e) {
        return e && e.parentNode.removeChild(e);
      }), this._tags = []) : this._serverSheet.cssRules = [];
    }, i.cssRules = function() {
      var e = this;
      return typeof window > "u" ? this._serverSheet.cssRules : this._tags.reduce(function(t, r) {
        return r ? t = t.concat(Array.prototype.map.call(e.getSheetForTag(r).cssRules, function(o) {
          return o.cssText === e._deletedRulePlaceholder ? null : o;
        })) : t.push(null), t;
      }, []);
    }, i.makeStyleTag = function(e, t, r) {
      t && c(z(t), "makeStyleTag accepts only strings as second parameter");
      var o = document.createElement("style");
      this._nonce && o.setAttribute("nonce", this._nonce), o.type = "text/css", o.setAttribute("data-" + e, ""), t && o.appendChild(document.createTextNode(t));
      var u = document.head || document.getElementsByTagName("head")[0];
      return r ? u.insertBefore(o, r) : u.appendChild(o), o;
    }, L(n, [
      {
        key: "length",
        get: function() {
          return this._rulesCount;
        }
      }
    ]), n;
  }();
  function c(n, i) {
    if (!n)
      throw new Error("StyleSheet: " + i + ".");
  }
  function D(n) {
    for (var i = 5381, s = n.length; s; )
      i = i * 33 ^ n.charCodeAt(--s);
    return i >>> 0;
  }
  var G = D, H = function(n) {
    return n.replace(/\/style/gi, "\\/style");
  }, f = {};
  function C(n, i) {
    if (!i)
      return "jsx-" + n;
    var s = String(i), e = n + s;
    return f[e] || (f[e] = "jsx-" + G(n + "-" + s)), f[e];
  }
  function O(n, i) {
    var s = /__jsx-style-dynamic-selector/g;
    typeof window > "u" && (i = H(i));
    var e = n + i;
    return f[e] || (f[e] = i.replace(s, n)), f[e];
  }
  function J(n, i) {
    return i === void 0 && (i = {}), n.map(function(s) {
      var e = s[0], t = s[1];
      return /* @__PURE__ */ h.default.createElement("style", {
        id: "__" + e,
        // Avoid warnings upon render with a key
        key: "__" + e,
        nonce: i.nonce ? i.nonce : void 0,
        dangerouslySetInnerHTML: {
          __html: t
        }
      });
    });
  }
  var M = /* @__PURE__ */ function() {
    function n(s) {
      var e = s === void 0 ? {} : s, t = e.styleSheet, r = t === void 0 ? null : t, o = e.optimizeForSpeed, u = o === void 0 ? !1 : o;
      this._sheet = r || new B({
        name: "styled-jsx",
        optimizeForSpeed: u
      }), this._sheet.inject(), r && typeof u == "boolean" && (this._sheet.setOptimizeForSpeed(u), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }
    var i = n.prototype;
    return i.add = function(e) {
      var t = this;
      this._optimizeForSpeed === void 0 && (this._optimizeForSpeed = Array.isArray(e.children), this._sheet.setOptimizeForSpeed(this._optimizeForSpeed), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), typeof window < "u" && !this._fromServer && (this._fromServer = this.selectFromServer(), this._instancesCounts = Object.keys(this._fromServer).reduce(function(p, Q) {
        return p[Q] = 0, p;
      }, {}));
      var r = this.getIdAndRules(e), o = r.styleId, u = r.rules;
      if (o in this._instancesCounts) {
        this._instancesCounts[o] += 1;
        return;
      }
      var _ = u.map(function(p) {
        return t._sheet.insertRule(p);
      }).filter(function(p) {
        return p !== -1;
      });
      this._indices[o] = _, this._instancesCounts[o] = 1;
    }, i.remove = function(e) {
      var t = this, r = this.getIdAndRules(e).styleId;
      if (X(r in this._instancesCounts, "styleId: `" + r + "` not found"), this._instancesCounts[r] -= 1, this._instancesCounts[r] < 1) {
        var o = this._fromServer && this._fromServer[r];
        o ? (o.parentNode.removeChild(o), delete this._fromServer[r]) : (this._indices[r].forEach(function(u) {
          return t._sheet.deleteRule(u);
        }), delete this._indices[r]), delete this._instancesCounts[r];
      }
    }, i.update = function(e, t) {
      this.add(t), this.remove(e);
    }, i.flush = function() {
      this._sheet.flush(), this._sheet.inject(), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }, i.cssRules = function() {
      var e = this, t = this._fromServer ? Object.keys(this._fromServer).map(function(o) {
        return [
          o,
          e._fromServer[o]
        ];
      }) : [], r = this._sheet.cssRules();
      return t.concat(Object.keys(this._indices).map(function(o) {
        return [
          o,
          e._indices[o].map(function(u) {
            return r[u].cssText;
          }).join(e._optimizeForSpeed ? "" : `
`)
        ];
      }).filter(function(o) {
        return !!o[1];
      }));
    }, i.styles = function(e) {
      return J(this.cssRules(), e);
    }, i.getIdAndRules = function(e) {
      var t = e.children, r = e.dynamic, o = e.id;
      if (r) {
        var u = C(o, r);
        return {
          styleId: u,
          rules: Array.isArray(t) ? t.map(function(_) {
            return O(u, _);
          }) : [
            O(u, t)
          ]
        };
      }
      return {
        styleId: C(o),
        rules: Array.isArray(t) ? t : [
          t
        ]
      };
    }, i.selectFromServer = function() {
      var e = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
      return e.reduce(function(t, r) {
        var o = r.id.slice(2);
        return t[o] = r, t;
      }, {});
    }, n;
  }();
  function X(n, i) {
    if (!n)
      throw new Error("StyleSheetRegistry: " + i + ".");
  }
  var k = /* @__PURE__ */ l.createContext(null);
  k.displayName = "StyleSheetContext";
  function $() {
    return new M();
  }
  function V(n) {
    var i = n.registry, s = n.children, e = l.useContext(k), t = l.useState(function() {
      return e || i || $();
    }), r = t[0];
    return /* @__PURE__ */ h.default.createElement(k.Provider, {
      value: r
    }, s);
  }
  function N() {
    return l.useContext(k);
  }
  var K = h.default.useInsertionEffect || h.default.useLayoutEffect, T = typeof window < "u" ? $() : void 0;
  function E(n) {
    var i = T || N();
    return i ? typeof window > "u" ? (i.add(n), null) : (K(function() {
      return i.add(n), function() {
        i.remove(n);
      };
    }, [
      n.id,
      String(n.dynamic)
    ]), null) : null;
  }
  return E.dynamic = function(n) {
    return n.map(function(i) {
      var s = i[0], e = i[1];
      return C(s, e);
    }).join(" ");
  }, m.StyleRegistry = V, m.createStyleRegistry = $, m.style = E, m.useStyleRegistry = N, m;
}
var A, P;
function Z() {
  return P || (P = 1, A = Y().style), A;
}
var ee = Z();
const R = /* @__PURE__ */ W(ee), S = [".interlinking-footer__link.jsx-4087935969{list-style:none;}", ".interlinking-footer__link-anchor.jsx-4087935969{-webkit-text-decoration:none;text-decoration:none;cursor:pointer;color:#717171;line-height:14px;font-size:10px;font-weight:400;display:inline-block;width:140px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"];
S.__hash = "4087935969";
const te = ({
  name: l,
  url: d
}) => /* @__PURE__ */ y(v, { children: [
  /* @__PURE__ */ a(R, { id: S.__hash, children: S }),
  /* @__PURE__ */ a("li", { className: `jsx-${S.__hash} interlinking-footer__link`, children: /* @__PURE__ */ a("a", { href: d, className: `jsx-${S.__hash} interlinking-footer__link-anchor`, children: l }) })
] }), q = "320px", ie = "1024px", j = [".interlinking-footer__links.jsx-1213806272{margin-block-start:0;}", `@media (min-width:${q}){.interlinking-footer__links.jsx-1213806272{padding-inline-start:0;}}`];
j.__hash = "1213806272";
const ne = ({
  links: l
}) => {
  const d = l.filter((h) => h.name.trim());
  return /* @__PURE__ */ y(v, { children: [
    /* @__PURE__ */ a(R, { id: j.__hash, children: j }),
    /* @__PURE__ */ a("ul", { "data-testid": "links", className: `jsx-${j.__hash} interlinking-footer__links`, children: d.map((h, b) => /* @__PURE__ */ a(te, { name: h.name, url: h.url }, `link_${b}`)) })
  ] });
}, g = [".interlinking__group-title.jsx-3886111654{padding-inline-start:40px;line-height:16px;font-size:12px;font-weight:700;display:inline-block;width:140px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}", `@media (min-width:${q}){.interlinking__group-title.jsx-3886111654{padding-inline-start:0;}}`];
g.__hash = "3886111654";
const re = ({
  title: l,
  links: d
}) => /* @__PURE__ */ y(v, { children: [
  /* @__PURE__ */ a(R, { id: g.__hash, children: g }),
  /* @__PURE__ */ y("section", { className: `jsx-${g.__hash} interlinking-footer__group`, children: [
    l.trim() && /* @__PURE__ */ a("h3", { "data-testid": "group-title", className: `jsx-${g.__hash} interlinking__group-title`, children: l }),
    /* @__PURE__ */ a(ne, { links: d })
  ] })
] }), x = [".interlinking-footer__groups.jsx-1238869708{box-sizing:border-box;display:grid;grid-template-columns:repeat(2,1fr);gap:26px;line-height:14px;font-weight:400;justify-items:center;}", `@media (min-width:${ie}){.interlinking-footer__groups.jsx-1238869708{grid-template-columns:repeat(4,1fr);}}`];
x.__hash = "1238869708";
const se = ({
  groups: l
}) => /* @__PURE__ */ y(v, { children: [
  /* @__PURE__ */ a(R, { id: x.__hash, children: x }),
  /* @__PURE__ */ a("div", { "data-testid": "groups", className: `jsx-${x.__hash} interlinking-footer__groups`, children: l.map((d, h) => /* @__PURE__ */ a(re, { title: d.title, links: d.links }, `group_${h}`)) })
] }), F = [".interlinking-footer.jsx-153847333{box-sizing:border-box;padding:16px;background:#f9f9f9;color:#717171;font-family:Lato;max-width:1280px;width:100%;margin:0 auto;}"];
F.__hash = "153847333";
const ue = ({
  groups: l
}) => /* @__PURE__ */ y(v, { children: [
  /* @__PURE__ */ a(R, { id: F.__hash, children: F }),
  /* @__PURE__ */ a("article", { "data-testid": "InterlinkingFooter", className: `jsx-${F.__hash} interlinking-footer`, children: /* @__PURE__ */ a(se, { groups: l }) })
] });
export {
  ue as InterlinkingFooter,
  ue as default
};
